
        var result = require("!!../../../../node_modules/css-loader/index.js!./layout.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./app/components/layout/layout.component.css
// module id = 1422
// module chunks = 0